import { useMutation } from '@tanstack/react-query';

import { resendPhoneOtpApi } from '../api';

export default function useValidatePhoneMutation(config?: any) {
  return useMutation(resendPhoneOtpApi, config);
}
